import Vue from 'vue';
import * as api from '../../../../../scripts/services/api';
import * as blockui from '../../../../../helpers/block-ui';
import * as datatable from '../../../../../scripts/global/datatables';
import ActionModal from '../ActionModal/ActionModal.vue';

export default {
  data() {
    return {
      selectedAction: {},
      isUpdate: false,
    };
  },
  components: {
    'action-modal': ActionModal,
  },
  mounted() {
    const self = this; let
      table;
    const columns = [{
      data: 'Id',
      title: 'ID',
      sortable: true,
      width: 40,
      defaultContent: '',
    }, {
      data: 'ActionName',
      title: this.translate('action'),
      sortable: 'asc',
      width: 550,
      defaultContent: '',
    }, {
      data: 'ActionGroupName',
      title: this.translate('action_group'),
      sortable: 'asc',
      width: 550,
      defaultContent: '',
    }];

    const datatableContainer = '.action_list';

    Vue.getDatatables = () => {
      blockui.blockElement(self, '.m-portlet');
      const isDataTable = $.fn.DataTable.isDataTable(datatableContainer);
      api.getSecurityActionList().then((response) => {
        if (isDataTable) {
          const dt = $(datatableContainer).DataTable();
          dt.clear();
          dt.rows.add(response.body);
          dt.draw();
        } else {
          table = datatable.renderTable({
            exportFileName: self.translate('action'),
            container: datatableContainer,
            data: response.body,
            columns,
            paging: true,
            sortable: true,
          });
        }
        blockui.unBlockElement('.m-portlet');
      }, (error) => {
        blockui.unBlockElement('.m-portlet');
      });
    };

    Vue.getDatatables();

    window.$('#add_action_btn').on('click', () => {
      const modalContainer = window.$('#action_modal');
      modalContainer.modal({
        backdrop: 'static',
        show: true,
      });
      self.selectedAction = {};
      modalContainer.find('form').data('type', '');
      self.isUpdate = false;
    });
  },
};
